import { useMemo, useState } from "react";
import { collectionList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const categories = ["全部", "都市", "悬疑", "古装", "科幻"];

export default function CollectionSection() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? collectionList : collectionList.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section
      id="collections"
      className="w-full scroll-mt-20 border-b border-background-200 bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="热播合集索引"
            title="按题材整理的追剧片单，找片更快一步"
            desc="点击下方题材即可筛选正在热播与完结口碑的剧集，进入站点后搜索剧名即可开始观看。"
            tone="accent"
          />
          <div className="flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-50 p-1">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActive(cat)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === cat
                    ? "bg-accent-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
          {list.map((item) => (
            <li
              key={item.id}
              className="rise flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  《{item.title}》
                </h3>
                <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                  {item.category}
                </span>
              </div>
              <p className="text-xs leading-relaxed text-foreground-600">{item.summary}</p>
              <div className="mt-auto flex flex-wrap items-center gap-2 pt-1">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-md border border-background-200 bg-background-100 px-2 py-0.5 text-xs text-secondary-700"
                  >
                    {tag}
                  </span>
                ))}
                <span className="ml-auto text-xs text-foreground-500">{item.meta}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}